import { useEffect, useState } from "react";
import { Menu, X, Scissors } from "lucide-react";
import { BOOKSY_URL } from "@/lib/config";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { label: "Services", href: "#services" },
    { label: "House Calls", href: "#house-call" },
    { label: "Barbers", href: "#barbers" },
    { label: "Gallery", href: "#gallery" },
    { label: "About", href: "#about" },
    { label: "Contact", href: "#contact" },
  ];

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-black/70 backdrop-blur-xl border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-4 flex items-center justify-between">
        <a href="#hero" data-testid="brand-logo" className="flex items-center gap-2 group">
          <Scissors className="w-5 h-5 text-[#FF3333] group-hover:rotate-45 transition-transform duration-300" />
          <span className="font-display font-black text-xl tracking-tight uppercase">
            McNeal<span className="text-[#FF3333]">Cutz</span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase().replace(/ /g, "-")}-link`}
              className="text-sm uppercase tracking-[0.18em] font-medium text-white/70 hover:text-[#FF3333] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a
            data-testid="navbar-book-btn"
            href={BOOKSY_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-[#FF3333] text-black font-bold uppercase tracking-wider text-sm px-6 py-3 street-btn hover:bg-[#FF5C5C] transition-colors"
          >
            Book Now
          </a>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-white"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-black/95 backdrop-blur-xl border-t border-white/10">
          <div className="px-4 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-white/80 uppercase tracking-[0.18em] text-sm"
              >
                {l.label}
              </a>
            ))}
            <a
              data-testid="mobile-book-btn"
              href={BOOKSY_URL}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setOpen(false)}
              className="bg-[#FF3333] text-black font-bold uppercase tracking-wider text-sm px-6 py-3 mt-2 text-center"
            >
              Book Now
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
